<template>
    <div>

        <div class="row">
            <div class="col-lg-12">
                <div class="well text-right" v-show="!showFilters">
                    <button @click="toggleFilter()" class="btn btn-default">pokaż filtry</button>
                </div>

                <div class="well" v-show="showFilters">

                    <div class="row">
                        <div class="col-md-6">
                            <label>
                                Sklep wzorcowy:
                                <select name="sw" v-model="pivot" class="form-control">
                                    <option v-for="key in keys" v-bind:value="key">{{ names[key] }}</option>
                                </select>
                            </label>
                        </div>
                        <div class="col-md-6 text-right">
                            <button @click="toggleFilter()" class="btn btn-default">zamknij</button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4" v-for="attribute in attributes">
                            <label>
                                {{ attribute.name }}
                                <select v-bind:name="attribute.id" v-model="filter[attribute.id]" class="form-control">
                                    <option value="0">-</option>
                                    <option v-for="value in attribute.values" v-bind:value="value.id">{{ value.name }}</option>
                                </select>
                            </label>
                        </div>
                    </div>

                    <button @click="showFilters = false; buildDT()" class="btn btn-default">filtruj</button>

                </div>
            </div>
        </div>

        <div id="table-wrapper">

        </div>
        <!--<table id="example" class="stripe" cellspacing="0" width="100%">
            <thead>
            <tr>
                <th>First name</th>
                <th>Last name</th>
                <th>Position</th>
                <th>Office</th>
                <th>Age</th>
                <th>Start date</th>
                <th>Salary</th>
                <th>Extn.</th>
                <th>E-mail</th>
            </tr>
            </thead>
        </table>-->

        <!--<div class="table-wrapper">
            <table class="table table-striped table-bordered table-hover table-condensed">
                <thead>
                <tr>
                    <th v-for="key in keys">{{ names[key] }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in data">
                    <td v-for="key in keys">
                        <div v-for="product in item[key]">
                            {{product.name}}
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>-->
    </div>
</template>

<script>
    import 'jquery'

    require('datatables.net-bs');
    require('datatables.net-fixedcolumns');
//    import 'expose?$!expose?jQuery!jquery'
//    require('datatables.net-bs')(window, $);

    export default {
        data() {
            return {
                dt: {
                    instance: null,
                    columns: [],
                    options: {
                        language: {
                            "processing": this.$translate.text("Processing")+'...',
                            "search": this.$translate.text("Search")+':',
                            "lengthMenu": this.$translate.text("Show _MENU_ position"),
                            "info": this.$translate.text("Position _START_ - _END_ of _MAX_"),
                            "infoEmpty": this.$translate.text("Position 0 of 0 available"),
                            "infoFiltered": "",
                            "infoPostFix": "",
                            "loadingRecords": this.$translate.text("Loading")+'...',
                            "zeroRecords": this.$translate.text("Records not found"),
                            "emptyTable": this.$translate.text('Not found'),
                            "paginate": {
                                "first": this.$translate.text("First"),
                                "previous": this.$translate.text("Previous"),
                                "next": this.$translate.text("Next"),
                                "last": this.$translate.text("Last")
                            },
                            "aria": {
                                "sortAscending": ': ' + this.$translate.text("active to asc sort column"),
                                "sortDescending": ': '+ this.$translate.text("active to desc sort column")
                            }
                        },
                        scrollY: '55vh',
                        scrollX: true,
                        scrollCollapse: true,
                        sort: false,
                        searching: false,
                        paging: true,
                        lengthMenu: [[100, 250, 500], [100, 250, 500]],
                        fixedColumns: {
                            leftColumns: 2
                        },
                        renderer: 'bootstrap',
                        processing: true,
                        serverSide: true,
                        ajax: {
                            url: 'http://api-merge.pd.local/getdt'
                        }
                    }
                },

                showFilters: false,
                filter: {},
                pivot: '',
                attributes: [],
                data: [],
                keys: [],
                names: {
                    x: '-',
                    komputronik: 'Komputronik',
                    xkom: 'X-Kom',
                    euro: 'Euro RTV AGD',
                    oleole: 'Ole Ole!',
                    mediamarkt: 'Media Markt',
                    mediaexpert: 'Media Expert',
                    morele: 'Morele',
                    agito: 'eMAG (Agito)',
                    neonet: 'Noenet',
                    saturn: 'Saturn',
                    neo24: 'Neo24',
                    redcoon: 'Redcoon',
                    mall: 'MALL',
                    proline: 'Proline',
                    sferis: 'Sferis',
                    electro: 'Electro'
                }
            }
        },

        mounted() {
            this.start()
//            this.test()

        },
        updated() {
            this.fixTable()
        },
        methods: {
            buildDT() {
                var i
                var tmpColumns = this.dt.columns
                this.dt.columns = [
                    {data: 'x', name: this.names['x']},
                    {data: this.pivot, name: this.names[this.pivot]}
                ]
                for (i in tmpColumns) {
                    if (tmpColumns.hasOwnProperty(i)) {
                        if (tmpColumns[i].data != 'x' && tmpColumns[i].data != this.pivot) {
                            this.dt.columns.push(tmpColumns[i])
                        }
                    }
                }

                var tableHeaders = ''
                for (i in this.dt.columns) {
                    if (this.dt.columns.hasOwnProperty(i)) {
                        tableHeaders += '<th>' + this.dt.columns[i].name + '</th>';
                    }
                }

                if (this.dt.instance != null) {
                    //this.dt.instance.destroy();
                }

                $('#table-wrapper')
                        .empty()
                        .append('<table id="displayTable" class="display cell-border compact" cellspacing="0" width="100%"><thead><tr>' + tableHeaders + '</tr></thead></table>');

                var pivot = this.pivot
                var category = this.$route.params.id
                var attributes = this.filter

                this.dt.options.ajax.data = function(d) {
                    delete d.columns
                    delete d.order
                    delete d.search
                    d.pivot = pivot
                    d.category = category
                    d.attributes = attributes
                }
                this.dt.options.columns = this.dt.columns
                this.dt.options.aoColumns = this.dt.columns

                this.dt.instance = $('#displayTable').dataTable(this.dt.options);
            },
            start() {
                this.$http.get('attributes/' + this.$route.params.id).then((response) => {
                    for (var i in response.body.attributes) {
                        if (response.body.attributes.hasOwnProperty(i)) {
                            this.filter[response.body.attributes[i].id] = 0
                        }
                    }
                    this.attributes = response.body.attributes
                    this.dt.columns = response.body.columns
                    this.keys = response.body.keys
                    if (!this.pivot) this.pivot = 'komputronik'
                    //this.getData()
                    this.buildDT();
                })
            },
            getData() {

//                var table = $('#example').DataTable();

                /*
                this.$http.get('http://api-merge.pd.local/get2', {
                    params: {
                        'pivot': this.pivot,
                        'category': this.$route.params.id,
                        'attributes': this.filter
                    }
                }).then((response) => {
                    if (!response.body.length) {
                        this.data = []
                    }
                    else {
                        this.keys = Object.keys(response.body[0])
                        console.log(response.body)
                        this.data = response.body
                        if (!this.pivot) this.pivot = 'komputronik'
                        this.fixTable()
                    }
                })*/
            },
            fixTable() {
                $('.fixed-column').remove();
                var $table = $('.table');
                var $fixedColumn = $table.clone().insertBefore($table).addClass('fixed-column');

                $fixedColumn.find('th:not(:first-child, :nth-child(2)),td:not(:first-child, :nth-child(2))').remove();

                $fixedColumn.find('tr').each(function (i, elem) {
                    $(this).height($table.find('tr:eq(' + i + ')').height());
                    $(this).find('td:first-child').width($table.find('tr:eq(' + i + ')').find('td:first-child').width());
                    $(this).find('td:nth-child(2)').width($table.find('tr:eq(' + i + ')').find('td:nth-child(2)').width());
                });
            },
            toggleFilter() {
                this.showFilters = !this.showFilters
            }
        }
    }
</script>

<style>
    .well {
        z-index: 1;
        position: relative;
    }
    /*.table-wrapper {*/
        /*overflow: auto;*/
        /*position: absolute;*/
        /*right: 15px;*/
        /*left: 15px;*/
        /*bottom: 15px;*/
        /*top: 150px;*/
    /*}*/
    /*.table-responsive > .fixed-column {*/
        /*position: absolute;*/
        /*!*display: inline-block;*!*/
        /*width: auto;*/
        /*border-right: 3px solid #ddd;*/
        /*background: #fff;*/
    /*}*/

    label {
        width: 100%;
    }
    /*.table-responsive tr,
    .table-responsive th {
        height: 35px;
        max-height: 35px;
        overflow: hidden;
    }*/

    .dataTable tbody tr {
        height: 35px; /* or whatever height you need to make them all consistent */
    }
    .dataTable th {
        background: #fff;
    }
</style>


// WEBPACK FOOTER //
// Table.vue?ac98a8c0